<template>
  <select
    v-model="selected"
    name="country"
  >
    <option v-for="(country, index) in countries" :value="index">{{country}}</option>
  </select>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'CountrySelect',
  props: ['country'],
  model: {
    prop: 'country',
    event: 'input'
  },
  computed: {
    ...mapState({
      countries: state => state.addressBookModule.allowedCountriesList,
    }),
    selected: {
      get(){
        return this.country
      },
      set(value){
        this.$emit('input',value);
      }
    }
  }
};
</script>

<style scoped></style>
